/*
 * @Author: lvbl
 * @Date: 2021-10-11 10:09:11
 * @LastEditTime: 2021-11-04 15:44:00
 * @Description: In User Settings Edit
 * @FilePath: \ljsite-vue\src\router\nportal.js
 */
// 路由基础配置文件
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { bj, routerMapDeal } from '@/router/nportal/index.js'

Vue.use(Router)

//push 
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to) {
        return VueRouterReplace.call(this, to).catch(err => err)
    }
    //路由表
let new_hlj = bj.map(routerItem => {
    let item = routerMapDeal(routerItem)
    return item[0]
})
const router = new Router({
    mode: 'hash',
    // base: process.env.BASE_URL,
    base: "/",
    routes: [{
        'path': '/',
        component: () =>
            import (`@/views/nportal/views/layout/Layout`),
    }, ...new_hlj],
    // 页面切换后滚动到顶部
    scrollBehavior: () => ({ y: 0 })
})
router.beforeEach((to, from, next) => {
    // 合规：任何路由切换都触发“个人信息保护提醒”（仅影响视觉，不阻断渲染）
    if (typeof window !== 'undefined') {
        try {
            window.dispatchEvent(new Event('lj:pip:trigger'))
        } catch (e) {}
    }

    if (to.query.id) {
         next({
            hash: to.query.id,
            name: 'CustomPage',
            replace: true
        })
    }
    if (to.hash == '#cpfa') {
        next({
            fullPath: "/lj/CustomPage",
            hash: "#digital",
            name: null,
            path: "/lj/CustomPage",
            replace: true
        })
    }
    const title = store.getters.metaTitle;
    if (title) {
        //document.title = "龙即信息 " + title
    }
    if (to.path !== "/") {
        //编辑时取用户信息
        if (to.path.indexOf("edit") > -1) {
            //定制编辑页跳转逻辑
            //运维跳转过来的页面编辑 ，code在此获取 
            let localHerf = window.location.href;
            if (localHerf.indexOf("?code") > -1 && !to.query.code) {
                let slice_1 = localHerf.split("?code=");
                let slice_2 = slice_1[1].split('#');
                let code = slice_2[0];
                let target = slice_1[0] + `#${slice_2[1]}` + `?code=${code}` + `#${slice_2[2]}`;
                store.dispatch('GetToken', code).then(() => {
                    store.dispatch('GetUserInfo', 'home').then(() => {
                        window.location.href = target;
                    })
                })
            } else {
                store.dispatch('GetUserInfo', 'home').then(() => {
                    next()
                })
            }
        } else {
            next()
        }
    } else {
        
    
        //浏览器输入ip+端口 ，跳转到首页
        next({
            fullPath: "/lj/CustomPage",
            hash: "#Home",
            name: null,
            path: "/lj/CustomPage",
            replace: true
        })
    }
})

router.afterEach((to, from) => {
    //请求主题色、获取头部标题
    let theme = store.getters.stationTheme;
    if (!theme && to.params.station) {
        store.dispatch("GetTheme", to.params.station).then(() => {})
    }
})
export default router